import { Checkbox, Col, Form, FormInstance, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const RespiratorySymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasRespiratory =
    Form.useWatch(['form', 'symptoms', 'respiratory', 'status'], form) === 'yes'

  const hasCough = Form.useWatch(
    ['form', 'symptoms', 'respiratory', 'cough', 'isSelected'],
    form
  )

  const hasTonsillitis = Form.useWatch(
    ['form', 'symptoms', 'respiratory', 'tonsillitis', 'isSelected'],
    form
  )

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'respiratory', 'status']}
          rules={requiredRules}
          label={`5. ${t('epidemiology.respiratory')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasRespiratory && (
        <>
          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'respiratory',
                'rhinitis',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>1. Rinită</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'respiratory',
                'nasalHemorrhage',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>2. Hemoragie nazală</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'respiratory',
                'pharyngitisLaryngitis',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>3. Faringită / laringită</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'respiratory',
                'aerophobia',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>4. Aerofobie</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'respiratory', 'cough', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>5. Tuse</Checkbox>
            </Form.Item>
          </Col>

          {hasCough && (
            <>
              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'cough',
                    'oneToTwoWeeks',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>5.1 1-2 săptămâni</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'cough',
                    'moreThanTwoWeeks',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>5.2 Mai mult de 2 săptămâni</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'cough',
                    'paroxysmal',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>5.3 Paroxistică</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'cough',
                    'mucopurulent',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>5.4 Mucopurulentă</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'cough',
                    'bloodySputum',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>5.5 Spută cu sânge</Checkbox>
                </Form.Item>
              </Col>
            </>
          )}

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'respiratory',
                'tonsillitis',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>6. Amigdalită</Checkbox>
            </Form.Item>
          </Col>

          {hasTonsillitis && (
            <>
              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'tonsillitis',
                    'membranous',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>6.1 Membranoasă</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'tonsillitis',
                    'cataral',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>6.2 Catarală</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'tonsillitis',
                    'purulent',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>6.3 Purulentă</Checkbox>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'respiratory',
                    'tonsillitis',
                    'necrotic',
                    'isSelected'
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox>6.4 Necrotică</Checkbox>
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
    </>
  )
}
